export default (state, action) => {
  return Object.assign({}, state, {
    request: action.request,
    address: action.address,
    loading: true
  });
};
